module.exports = __webpack_public_path__ + "media/mam-trim-transcode.07237c10.mp4";